import { render, staticRenderFns } from "./increased.vue?vue&type=template&id=9f700a7a&scoped=true&"
import script from "./increased.vue?vue&type=script&lang=js&"
export * from "./increased.vue?vue&type=script&lang=js&"
import style0 from "./increased.vue?vue&type=style&index=0&id=9f700a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f700a7a",
  null
  
)

export default component.exports